import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import SegmentedSwitch from './segmented-switch';
import { ICONS } from '@ui/icons/types';

const ALIGN_OPTIONS = [
  { value: 'left', icon: ICONS.ALIGN_LEFT, ariaLabel: 'Align left' },
  { value: 'center', icon: ICONS.ALIGN_CENTER, ariaLabel: 'Align center' },
  { value: 'right', icon: ICONS.ALIGN_RIGHT, ariaLabel: 'Align right' },
];

interface AlignmentControlProps {
  value: string;
  onChange: (value: string) => void;
}

export default function AlignmentControl({ value, onChange }: AlignmentControlProps) {
  return (
    <Container className="flex-column gap-2 flex-1">
      <Text tag="label" design="GlobalIcoText3" className="L2 padding-l-16">
        Alignment
      </Text>
      <SegmentedSwitch value={value} options={ALIGN_OPTIONS} onChange={onChange} />
    </Container>
  );
}
